import Footer from "@/components/@extended/Footer";
import MainBox from "@/components/Box/MainBox";
import { handleBackActiveStep, handleNextActiveStep, selectProject } from "@/redux/features/Service/serviceSlice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { FormControl, Grid } from "@mui/material";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import StyleTextField from "@/components/TextField";
import Item from "@/components/Grid/Item";
import Label from "@/components/Label/Label";
import { useProjectUserLoginMutation } from "@/redux/features/Service/serviceApi";
import { ErrorMessage } from "@/components/Message/AlertMessage";
import useMessage from "@/useHooks/useMessage";
import { setSession } from "@/utils/Session";

const Layout = () => {

  const dispatch = useAppDispatch();

  const { message } = useMessage();

  const [loading, setLoading] = useState(false);

  const service = useAppSelector(selectProject);

  const [
    loginUser,
    {
      data: loginUserData,
      isSuccess: isLoginUserSuccess,
      isError: isLoginUserError,
      error: loginUserError,
    },
  ] = useProjectUserLoginMutation();

  const validationSchema = Yup.object().shape({
    account: Yup.string().required("yup_empty_hint"),
    password: Yup.string().required("yup_empty_hint"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      account: "",
      password: "",
    },
  });

  useEffect(() => {
    if (isLoginUserSuccess && loginUserData) {
      setSession("_SID", loginUserData.accounttoken);
      setLoading(false);
      dispatch(handleNextActiveStep());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoginUserSuccess, loginUserData]);

  useEffect(() => {
    if (isLoginUserError && loginUserError) {
      ErrorMessage(message(loginUserError));
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoginUserError, loginUserError]);

  const handleOnBackClick = () => {
    dispatch(handleBackActiveStep());
  };

  const handleOnNextClick = handleSubmit((data) => {



    loginUser({ clientId: service.project, mail: data.account, password: data.password });

    setLoading(true);

  });


  return (
    <MainBox height={"100%"} isLoading={loading}>
      <FormControl
        sx={{
          width: "100%",
          minHeight: "calc(100% - 50px)"
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid item xs={2}>
            <Item>
              <Label
                sx={{ fontSize: "1.3rem " }}
                id={"page_two_account"}
              />
            </Item>
          </Grid>
          <Grid item xs={10}>
            <StyleTextField
              id="account"
              {...register("account")}
              hiddenLabel
              variant="outlined"
              size="small"
              fullWidth
              error={errors.account ? true : false}
              helperText={
                errors.account && errors.account.message ? (
                  <Label id={errors.account.message} />
                ) : (
                  ""
                )
              }
            />
          </Grid>
          <Grid item xs={2}>
            <Item>

              <Label
                sx={{ fontSize: "1.3rem " }}
                id={"page_two_password"}
              />
            </Item>
          </Grid>
          <Grid item xs={10}>
            <StyleTextField
              id="password"
              {...register("password")}
              hiddenLabel
              variant="outlined"
              size="small"
              type="password"
              fullWidth
              error={errors.password ? true : false}
              helperText={
                errors.password && errors.password.message ? (
                  <Label id={errors.password.message} />
                ) : (
                  ""
                )
              }
            />
          </Grid>
        </Grid>
      </FormControl>
      <Footer
        onBackClick={handleOnBackClick}
        onNextClick={handleOnNextClick}
      />
    </MainBox>
  );
};

export default Layout;
